export const MAX_FILENAME_LENGTH = 200;
